import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { _, StepComponent, ModalService, SharedFacade } from '@icc/configurator/shared';
import { AccessoriesService } from './accessories.service';
import { IccAccessory, IccAccessoryColor } from '@icc/construction-elements/types';
import { APP_CONFIG, AppConfigFactory, core } from '@icc/shared';
import { Subscription } from 'rxjs';
import { PriceService } from '@icc/price';
import { AccessoryFacade } from '../+state/accessory.facade';

@Component({
    selector: 'icc-accessories',
    templateUrl: './accessories.component.html',
    styleUrls: ['./accessories.component.scss'],
    standalone: false
})
export class AccessoriesComponent extends StepComponent implements OnInit, OnDestroy {
    static stepName = _('ACCESSORY|Dodatki i akcesoria');
    static stepIcon = {
        ligature: 'reorder',
    };

    public configurator = 'accessory';
    public stepId = 'accessories';
    public title = _('ACCESSORY|Dodatki');
    public options = [];

    currency: any = {};

    accessories$ = this.accessoriesFacade.accessories$;
    windowAccessoriesManufacturerCode = this.config().IccConfig.Configurators
        .windowAccessoriesManufacturerCode;
    windowAccessoriesCounterControl = this.config().IccConfig.Configurators
        .windowAccessoriesCounterControl;
    showCoreColorInAdditionalProfilesAndAccessories = this.config().IccConfig.Configurators
        .showCoreColorInAdditionalProfilesAndAccessories;
    commentInAccessory = this.config().IccConfig.Configurators.commentInAccessory;

    protected subscriptions: Subscription[] = [];
    hiddenPrice = false;

    constructor(
        protected accessoriesFacade: AccessoryFacade,
        protected sharedFacade: SharedFacade,
        protected modalService: ModalService,
        protected accessoriesService: AccessoriesService,
        protected priceService: PriceService,
        @Inject(APP_CONFIG) protected config: AppConfigFactory
    ) {
        super();
    }

    ngOnInit() {
         this.hiddenPrice = (this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator)
            || (this.config().IccConfig.Configurators.hideProfilePrice);
        this.subscriptions.push(
            this.sharedFacade.currency$.subscribe(currency => {
                this.currency = currency;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    addAccessoriesToConstruction() {
        this.accessoriesService.openModalAccessories().then(result => {
            if (result) {
                this.sharedFacade.closePage();
            }
        });
    }

    remove(sash: any, accessory: IccAccessory, type?: string) {
        this.accessoriesService.remove(sash, accessory);
    }

    getColor(colorId, colors = this.accessoriesService.colorsAll) {
        const color = core.fIdO(colors, colorId);
        if (color) {
            return color.name;
        }
    }

    getAccessoryImage(accessory) {
        if(!!(accessory.price_source == 'colors' && accessory.colors_imgs && accessory.selectedColor && accessory.colors_imgs[accessory.selectedColor])) {
            return '/files/windowhandlescolorswindowaccessory/' + accessory.colors_imgs[accessory.selectedColor];
        }
        return '/files/windowaccessory/' + accessory.img;
    }

    getAccessoryPrice(accessory: IccAccessory, listPrice = false) {
        return this.accessoriesService.getAccessoryPrice(accessory, listPrice);
    }

    getAccessoryColors(accessory: IccAccessory) {
        return (this.accessoriesService.colorsAll || []).filter(
            c =>
                accessory.accessory.colors_ids
                && accessory.accessory.colors_ids.map(Number).includes(Number(c.id))
        );
    }

    changeAccessoryColor(accessory: IccAccessory) {
        this.accessoriesService.setAccessoryColor(accessory, this.accessoriesService.colorsAll)
        this.priceService.count();
    }
}
